import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  warehouseOrderEventsLoad,
  warehouseOrderLoad,
  warehouseOrderOrderSearch,
  warehouseOrderPair,
  warehouseOrderRecalculate,
  warehouseOrderReportLoad,
  warehouseOrdersLoad,
  warehouseOrdersLoadByOrder,
  warehouseOrdersRecalculate,
  warehouseOrdersSync,
  warehouseOrderUnpair,
  warehouseOrderUnpairedProductPair,
  warehouseOrderUnpairedProductsLoad,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(warehouseOrdersLoad.type, send, socket);
  yield takeEvery(warehouseOrderLoad.type, send, socket);
  yield takeEvery(warehouseOrderPair.type, send, socket);
  yield takeEvery(warehouseOrderUnpair.type, send, socket);
  yield takeEvery(warehouseOrderRecalculate.type, send, socket);
  yield takeEvery(warehouseOrderOrderSearch.type, send, socket);
  yield takeEvery(warehouseOrderEventsLoad.type, send, socket);
  yield takeEvery(warehouseOrderReportLoad.type, send, socket);
  yield takeEvery(warehouseOrdersSync.type, send, socket);
  yield takeEvery(warehouseOrdersLoadByOrder.type, send, socket);
  yield takeEvery(warehouseOrdersRecalculate.type, send, socket);
  yield takeEvery(warehouseOrderUnpairedProductsLoad.type, send, socket);
  yield takeEvery(warehouseOrderUnpairedProductPair.type, send, socket);
}
